import { SelectionModel } from '@angular/cdk/collections';

export abstract class AbstractSelectionModel<T> extends SelectionModel<T> {
  /**
   * Toggles a value between selected and deselected.
   */
  toggle(entity: T): void {
    // SelectionModel works with references. So, when the user navigates between pages
    // the row reference changes, so for the model is a new row. This causes some big problems
    // of usability because the selection is not consistent.

    let newSelection: T[] = [];
    if (this.isSelected(entity)) {
      // Item is selected... create a new selection without that item
      this.selected.filter(r => !this.equals(r, entity)).forEach(r => newSelection.push(r));
    } else {
      // Add the item to the list
      this.selected.forEach(r => newSelection.push(r));
      newSelection.push(entity);
    }
    // Rebuild the selection
    this.clear();
    newSelection.forEach(r => this.select(r));
  }

  /**
   * Check if an entity is selected
   *
   * @param row the entity
   * @return true if selected
   */
  isSelected(entity: T): boolean {
    return this.selected.some(element => this.equals(element, entity));
  }

  protected abstract equals(a: T, b: T);
}
